import { render } from "./MultiClipperLayout.vue?vue&type=template&id=ec15acf0&scoped=true"
import script from "./MultiClipperLayout.vue?vue&type=script&lang=js"
export * from "./MultiClipperLayout.vue?vue&type=script&lang=js"

import "./MultiClipperLayout.vue?vue&type=style&index=0&id=ec15acf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec15acf0"]])

export default __exports__